import axios from "axios";
import { API_PATHS } from "../utils/constants/api.constants";

class HotelAdmin {
    static hotelAdmin() {
        return axios
            .get(API_PATHS.hotelAdmins)
            .then((response) => {
                if (response.data) {
                    // localStorage.setItem("user", JSON.stringify(response.data));
                }
                return response.data;
            });
    }

    static removeUserDetails() {
        localStorage.removeItem("user");
    }

    static getUserDetails() {
        return JSON.parse(localStorage.getItem("user"));
    }
}

export default HotelAdmin;